import { render, staticRenderFns } from "./MainHero.vue?vue&type=template&id=5c658863&"
import script from "./MainHero.vue?vue&type=script&lang=js&"
export * from "./MainHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports